<template>
  <div class="page">
    <!-- <van-skeleton :row="10" :loading="recordeList.length === 0"> -->
    <empty v-if="recordeList.length === 0" txt="暂无续费记录" />
    <ul v-else class="record-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <li v-for="(item, index) in recordeList" :key="index" class="block">
            <div class="line">
              <div class="title ml_20">
                {{ item.orderItemInfoList[0].productName }}
              </div>
              <div class="cl pb_5 ml_20">
                支付时间: {{ item.paymentTime | formatTime }}
              </div>
            </div>
            <div class="line p_10">
              <div class="cl ml_20">
                绑定车辆: {{ item.orderItemInfoList[0].cpspOrderJson }}
              </div>
              <div class="cl ml_20">车架号: {{ item.vehicleVin }}</div>
            </div>
            <div class="p_10">
              <div class="cl ml_20">订单编号: {{ item.orderNo }}</div>
              <div class="cl ml_20">
                订单价格: {{ payAmount(item.payAmount) + "元" }}
              </div>
            </div>
            <!-- <div class="content">
                <van-cell-group>
                  <van-cell title="绑定车辆" :value="item.orderItemInfoList[0].cpspOrderJson" />
                  <van-cell title="车架号" :value="item.vehicleVin" />
                  <van-cell title="支付时间" :value="item.paymentTime | formatTime" />
                  <van-cell title="订单编号" :value="item.orderNo" />
                  <van-cell title="订单价格" :value="payAmount(item.payAmount) + '元'" />
                </van-cell-group>
              </div> -->
          </li>
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>

<script>
import { getRenewalRecordList } from "../../helper/api/service-renewal";
// import BScroll from 'better-scroll'
import dayjs from "dayjs";
import Empty from "../../components/Empty";

export default {
  name: "RecordList",
  components: {
    Empty
  },
  filters: {
    formatTime(val) {
      return val
        ? dayjs(+val).format("YYYY/MM/DD HH:mm:ss")
        : "--:--:-- --:--:--";
    }
  },
  data() {
    return {
      recordeList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageIndex: 1,
      serviceRenewalInfo: {},
      headers: {}
    };
  },
  computed: {
    payAmount() {
      return function(val) {
        return (val / 100).toFixed(2);
      };
    }
  },
  created() {
    this.$bridge.call("Controller.refreshNav", {
      right: [],
      fullScreen: false,
      hiddenNav: false,
      title: "续费记录"
    });
  },
  mounted() {
    this.$nextTick(() => {
      const serviceRenewalInfo = this.$bridge.call(
        "Storage.serviceRenewalInfo"
      );

      if (serviceRenewalInfo) {
        const {
          // eslint-disable-next-line no-unused-vars
          ssoId,
          // eslint-disable-next-line no-unused-vars
          tokenId,
          // eslint-disable-next-line no-unused-vars
          cVer,
          accessToken,
          brand,
          terminal,
          rs,
          enterpriseId,
          operatorRole
        } = serviceRenewalInfo;

        const headers = {
          brand,
          terminal,
          accessToken,
          rs,
          enterpriseId,
          operatorRole
        };

        this.serviceRenewalInfo = serviceRenewalInfo;
        this.headers = headers;

        this.onLoad();
      }
    });
  },
  methods: {
    onLoad() {
      // console.log('on loading')
      this._getRenewalRecordList();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    _getRenewalRecordList() {
      const params = {
        bizOrderType: "16",
        orderStatus: ["ORDER_COMP"],
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      getRenewalRecordList(params, this.headers).then(res => {
        if (this.refreshing) {
          // this.recordeList = []
          this.refreshing = false;
        }

        if (res.data.code === "000000") {
          if (res.data.data) {
            this.recordeList = [...this.recordeList, ...res.data.data.list];
            this.pageIndex++;
          }
        }

        this.loading = false;

        if (this.recordeList.length >= res.data.data.total) {
          this.finished = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../asset/scss/mixin.scss";

.page {
  width: 100%;
  min-height: 100vh;
  background: #f6f7fb;
  /deep/ .van-cell__title {
    flex: 1;
  }
  /deep/ .van-cell__value {
    flex: 2;
  }
  .record-list {
    padding: pxTorem(16);

    .block {
      margin-bottom: pxTorem(40);
      border-radius: pxTorem(4);
      background: #fff;
      overflow: hidden;
      padding: pxTorem(10) 0 0 0;
      .title {
        line-height: pxTorem(40);
        font-size: pxTorem(18);
        font-weight: 500;
        color: #272c31;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .cl {
        font-size: pxTorem(14);
        color: #696d77;
        line-height: pxTorem(35);
      }
      .line {
        border-bottom: pxTorem(1) dashed #d8d8d8;
      }
      .p_10 {
        font-size: pxTorem(14);
        padding-top: pxTorem(10);
        padding-bottom: pxTorem(10);
      }
      .pb_5 {
        padding-bottom: pxTorem(5);
      }
      .ml_20 {
        margin-left: pxTorem(20);
      }
    }
  }
}
</style>
